
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"24","viewBox":"0 0 22 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.61 8a3.99 3.99 0 01-2.678-1.032A4.003 4.003 0 013.804.082 3.998 3.998 0 018.42 2.8h7.708a4.056 4.056 0 013.218 1.607 4.069 4.069 0 01-1.712 6.225L5.253 15.6a1.663 1.663 0 00.615 3.2h7.713a3.997 3.997 0 012.552-2.596 3.99 3.99 0 013.595.552 4.002 4.002 0 010 6.488 3.99 3.99 0 01-3.596.552A3.997 3.997 0 0113.58 21.2H5.873a4.056 4.056 0 01-3.218-1.607 4.07 4.07 0 011.712-6.225l12.382-4.96a1.662 1.662 0 00.688-2.538 1.66 1.66 0 00-1.303-.662H8.42A3.998 3.998 0 014.61 8zm14.378 12a1.601 1.601 0 00-1.598-1.6 1.597 1.597 0 00-1.597 1.6 1.6 1.6 0 001.597 1.6 1.596 1.596 0 001.598-1.6zM3.012 4a1.601 1.601 0 001.597 1.6A1.597 1.597 0 006.207 4a1.601 1.601 0 00-1.598-1.6A1.596 1.596 0 003.012 4z","fill":"#D3C9FA"}})])
          )
        }
      }
    